import React, { useState, useEffect } from "react";
import { Divider, Skeleton } from "antd";
import { useQuery } from "@apollo/client";
import { GET_MESSAGE_NOTES } from "../../../../graphql/query";
import MessageNotesCard from "./MessageNotesCard";
import SendDirectMessage from "./SendDirectMessage";

const ViewMessageNotes = React.memo(
  ({ messageId, user, showAddNoteForm = false, updateDrawer, preferences }) => {
    // Fetch message notes for this messageId
    const {
      data: notesData,
      loading: notesLoading,
      refetch: refetchNotes,
    } = useQuery(GET_MESSAGE_NOTES, {
      variables: { messageId: +messageId },
      skip: !messageId,
      fetchPolicy: "network-only", // Always fetch from network
    });

    const handleAddNewNote = () => {
      // Hide the SendDirectMessage component by updating the drawer props
      updateDrawer({ showAddNoteForm: false });
    };

    return (
      <div className="w-full">
        {showAddNoteForm && (
          <div className="mb-5">
            <SendDirectMessage
              messageId={messageId}
              onCancel={handleAddNewNote}
              user={user}
              refetchNotes={refetchNotes}
              successCallback={handleAddNewNote}
              preferences={preferences}
            />
            <Divider />
          </div>
        )}

        {/* Original Message */}
        {/* <div>
          <p className="text-black/[0.65] text-sm font-semibold">Original Message</p>
          <div className="bg-[#CDDAE9] mt-3 p-4 rounded-xl text-black/[0.88] text-sm font-normal">
            {messageType?.toUpperCase() === EMAIL ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: messageEmail.replace(/^\n+/, "").replace(/\n/g, "<br />"),
                }}
              />
            ) : (
              messageContent
            )}
          </div>
        </div> */}

        <div>
          <p className="text-black/[0.65] mb-3 text-sm font-semibold">Message Notes</p>

          {notesLoading ? (
            <div className="space-y-4">
              {[...new Array(3)].map((_, idx) => (
                <Skeleton.Node key={idx} active style={{ height: "12rem" }} className="w-full" />
              ))}
            </div>
          ) : notesData?.getMessageNotes?.messageNoteObject?.length > 0 ? (
            <div className="space-y-4">
              {notesData?.getMessageNotes?.messageNoteObject?.map(note => (
                <MessageNotesCard
                  key={note.noteId}
                  note={note}
                  preferences={preferences}
                  refetchNotes={refetchNotes}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">No notes found for this message.</div>
          )}
        </div>
      </div>
    );
  }
);

ViewMessageNotes.displayName = "ViewMessageNotes";

export default ViewMessageNotes;
